// Severity levels for cell warnings
export enum CellWarningType {
  WARNING = 'warning',
  ERROR = 'error'
}

// Column keys to determine which field is being highlighted
export enum DetailHighlightType {
  TERM = 'term',
  SURVEY_TEMPLATE = 'survey_template',
  DATE_RANGE = 'date_range',
  ROLLING_RESULTS = 'rolling_results',
  RESULTS_RELEASE_DATE = 'results_release_date',
  OUTSIDE_TABLE = 'outside_table'
}

// Mapping of constraints to the relevant fields (in and outside table) for highlighting
export const constraintsMapping = {
  MISSING_TIMESTAMPS: {
    cell: ['start_timestamp', 'end_timestamp'],
    outside: [DetailHighlightType.DATE_RANGE]
  },
  START_TIME_OUTSIDE_RANGE: {
    cell: ['start_timestamp'],
    outside: [DetailHighlightType.DATE_RANGE]
  },
  END_TIME_OUTSIDE_RANGE: {
    cell: ['end_timestamp'],
    outside: [DetailHighlightType.DATE_RANGE]
  },
  MIN_DURATION: {
    cell: ['start_timestamp', 'end_timestamp'],
    outside: []
  },
  ADMIN_RELEASE_TIME_OUTSIDE_RANGE: {
    cell: ['early_access_release_timestamp_1'],
    outside: [DetailHighlightType.RESULTS_RELEASE_DATE]
  },
  INSTRUCTOR_RELEASE_TIME_OUTSIDE_RANGE: {
    cell: ['early_access_release_timestamp_2'],
    outside: [DetailHighlightType.RESULTS_RELEASE_DATE]
  },
  MIN_INSTRUCTOR: {
    cell: ['instructors'],
    outside: []
  },
  MIN_ENROLLMENT: {
    cell: ['linked_section.enrollment'],
    outside: []
  }
}

export type CellWarningConstraintType = keyof typeof constraintsMapping
